"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var _sizes = require("HubStyleTokens/sizes");

var _colors = require("HubStyleTokens/colors");

var _Use = require("./utils/Use");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var CLOSE_BUTTON_USE_COLOR_MAP = {
  default: _colors.EERIE,
  shepherd: _colors.OLAF,
  longform: _colors.CALYPSO,
  tooltip: _colors.OLAF,
  'tooltip-danger': _colors.OLAF,
  unstyled: _colors.EERIE
};
var StyledCloseButton = (0, _styledComponents.default)(_UICloseButton.default).withConfig({
  displayName: "UIPopoverCloseButton__StyledCloseButton",
  componentId: "affire-0"
})(["position:relative;margin-left:", ";right:0;left:0;top:", ";"], function (_ref) {
  var size = _ref.size;
  return size === 'sm' ? _sizes.SMALL_CLOSE_BUTTON_SIZE : _sizes.MEDIUM_CLOSE_BUTTON_SIZE;
}, function (_ref2) {
  var size = _ref2.size;
  return (size === 'sm' ? 0 : parseInt(_sizes.POPOVER_PADDING_X, 10) - parseInt(_sizes.POPOVER_PADDING_Y, 10)) + "px";
});
var UIPopoverCloseButton = (0, _memoWithDisplayName.default)('UIPopoverCloseButton', function (_ref3) {
  var popoverUse = _ref3.popoverUse,
      size = _ref3.size,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["popoverUse", "size"]);
  var computedColor = CLOSE_BUTTON_USE_COLOR_MAP[popoverUse];
  var shorthandSize = (0, _tshirtSize.toShorthandSize)(popoverUse === 'longform' ? 'sm' : size);
  return _react.default.createElement(StyledCloseButton, Object.assign({
    color: computedColor,
    size: shorthandSize
  }, rest));
});
UIPopoverCloseButton.propTypes = {
  color: _propTypes.default.string,
  size: _UICloseButton.default.propTypes.size,
  popoverUse: _propTypes.default.oneOf(Object.keys(_Use.USE_CLASSES))
};
UIPopoverCloseButton.defaultProps = {
  size: 'md',
  popoverUse: 'default'
};
var _default = UIPopoverCloseButton;
exports.default = _default;
module.exports = exports.default;